(function($){
    $.fn.timeline = function(){
        var _this = this, __init, __onScroll, _addListeners, _toggleFilter, _toggleActiveMonthEvents, _toggleYearcal, _setUpFilters, _changeBgColour, _categoryFilter;


        _toggleFilter = function(el){
            $(el).toggleClass("active");
            $(el).attr('aria-expanded', $(el).hasClass('active'));
            _this.find(".tags_container").toggleClass("filter_active");
            _this.find(".tags_container").slideToggle();
        };

        _toggleActiveMonthEvents = function(el){
            _this.find(".past-event").toggle();
            _this.find(".past-event").toggleClass("current-event");
            $(el.target).toggleClass('active');
            
            var span = $(el.target).find('span');

            if(span.text() === 'Show'){
                span.text('Hide');
            }else{
                span.text('Show');
            }
        };

        _changeBgColour = function(){
            // selectors
            var $window = $(window),
                $body = $('.events_calendar'),
                $panel = $('.month-container');
            if($body.hasClass('no_bg_animation')) return;
            // Change 33% earlier than scroll position so colour is there when you arrive.
            var scroll = $window.scrollTop() + ($window.height() / 5);
            $panel.each(function () {
                var $this = $(this);
                // if position is within range of this panel.
                // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
                // Remember we set the scroll to 33% earlier in scroll var.
                if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
                    // Remove all classes on body with color-
                    $body.removeClass(function (index, css) {
                        return (css.match (/(^|\s)color-\S+/g) || []).join(' ');
                    });
                    // Add class of currently active div
                    $body.addClass('color-' + $(this).data('name'));
                }
            });
        };

        _toggleYearcal = function(el){
            $(el).toggleClass("active");
            _this.find(".yearcal_mobile .yearcal_filter").toggleClass("yearcal_filter_active");
            _this.find(".yearcal_mobile .yearcal_filter").slideToggle();
        };

        _setUpFilters = function(){
            $('#taxonomy-container a:gt(0)').addClass('d-none');
            $('#taxonomy-container a').addClass('btn');

            _this.find('#base-layer [data-taxonomy]').each(function(k,e){
                var tax =$(e).data('taxonomy').toString();
                if(tax&&tax.includes(',')){
                    var taxes = tax.split(',');
                    taxes.forEach((t)=>{
                        _this.find('.tag-link-'+t).removeClass('d-none');
                    })
                }
                else{
                    _this.find('.tag-link-'+$(e).data('taxonomy')).removeClass('d-none');
                }
            });
        };

        _categoryFilter = function(el){
           $(el).toggleClass('active');
           if($(el).attr('href') === '#all' && $(el).hasClass('active')){
                _this.find('#taxonomy-container a:gt(0)').removeClass('active');
                //_this.find('.selected_filter_tags li').remove();
            }else if($(el).attr('href') === '#all' && !$(el).hasClass('active')){
                $(el).toggleClass('active');
            }else if($(el).hasClass('active')){
                _this.find('#taxonomy-container a:eq(0)').removeClass('active');
                //_this.find('.selected_filter_tags ul').append('<li id="selected-tag-'+slug+'">'+$(el).text()+' <i class="plus"></i></li>');
            }else if(!$(el).hasClass('active')){
                if(!_this.find('#taxonomy-container a:gt(0).active').length){
                    _this.find('#taxonomy-container a:eq(0)').addClass('active');
                }

                //_this.find('.selected_filter_tags #selected-tag-'+slug).remove();
            }

            var layer_name = [];
            var search_str = [];
            if(_this.find('#taxonomy-container a:gt(0).active').length){
                _this.find('#taxonomy-container a:gt(0).active').each(function(){
                    layer_name.push($(this).attr('href').replace('#', ""));
                    search_str.push('#base-layer .calendar-item[data-'+$(this).attr('href').replace('#', "")+']');
                });
                if(!_this.find('#layer-'+layer_name.join('-')).length){

                    var layer = $('<div/>').attr('id', 'layer-'+layer_name.join('-')).addClass('layer');

                    _this.find(search_str.join(', ')).not('.past-event').each(function(k, e){
                        var parent = $(e).parents('.month-container');
                        var item = $(e).clone();


                        var month_wrapper = layer.find('.month-container[data-year='+parent.data('year')+'][data-month='+parent.data('month')+']');

                        if(month_wrapper.length === 0){
                            month_wrapper = $('<div/>').addClass('month-container');
                            month_wrapper.attr('data-year', parent.data('year')).attr('data-month', parent.data('month')).attr('data-name', parent.data('name'));
                            if(parent.find('.display_month_sidebar')){
                                month_wrapper.append(parent.find('.display_month_sidebar').clone()).append('<div class="grid grid--33"></div>');
                            }
                            layer.append(month_wrapper);
                        }

                        month_wrapper.find('.grid:first').append(item);
                    });

                    _this.find('#events-container').append(layer);
                }

                _this.find('#events-container .layer.active').hide().removeClass('active');
                _this.find('#layer-'+layer_name.join('-')).show().addClass('active');
            } else {
                _this.find('#events-container .layer.active').hide().removeClass('active');
                _this.find('#base-layer').show().addClass('active');
            }


            //_this.find('.btn-info').removeClass('btn-info').addClass('btn-default');
            _this.find('a[data-month=' + $(this).data('month') + ']').removeClass('active');
            _this.find('.months_list a').each(function(k,element){
                $(element).removeClass('active');
            });
            _this.find('#events-container .layer.active .month-container').each(function(key, element){
                if($(element).find('.whats-on-item').length) {
                    var link = _this.find('a[data-month=' + $(this).data('month') + ']');
                    link.addClass('active');
                    link.attr('href',link.attr('data-link'));
                    _this.find('.months_list a:not(.active)').each(function(k,element){
                        $(element).attr('href', '');
                    });
                }else{
                    $(element).hide();
                }
            }); 
        };

        _addListeners = function(){
            // Filter toggle
            _this.find(".filter_button button").on('click', function(){
                _toggleFilter(this)
                console.log('clicked')
            });

            _this.find(".yearcal_mobile_btn").on('click', function(){
                _toggleYearcal(this)
            });
            _this.find('.show_past_events').on('click', function(e){
                _toggleActiveMonthEvents(e)
            });

            $('#taxonomy-container a').on('click', function(e){
                e.preventDefault();
                _categoryFilter(this)
            });



            $('#yearcal a.months').on('click', function(e){
                e.preventDefault();
                if(!$(this).hasClass('active')) return;
                let container = $('#events-container .layer.active .month-container[data-month='+$(this).data('month')+']');
                if (container.length !== 1){
                    container = $(container[container.length-1]);
                }
                $('html, body').animate({
                    scrollTop: container.offset().top-300
                }, 0);
                $( '#yearcal a.months' ).removeClass( "selected" );
                $(this).addClass( "selected" );
            });

        };

        __onScroll = function() {

            $(window).scroll(function() {
                var windscroll = $(window).scrollTop();

                if (windscroll >= 350) {
                    $('.events_grid .month-container').each(function(i) {
                        if ($(this).position().top <= windscroll - 350) {
                            $('.months_list li a.selected').removeClass('selected');
                            $('.months_list li a').eq(i).addClass('selected');
                        }
                    });
                } else {
                    $('.months_list li a.selected').removeClass('selected');
                    $('.months_list li a:first').addClass('selected');
                }

                _changeBgColour();
            });
        };

        __init = function(){
            _addListeners();
            __onScroll();
            _setUpFilters();
            _this.find('#events-container .layer.active .month-container').each(function(key, element){
                if($(element).find('.whats-on-item').length) {
                    var link = _this.find('a[data-month=' + $(this).data('month') + ']');
                    link.addClass('active');
                    link.attr('href',link.attr('data-link'));
                }else{
                    $(element).hide();
                }
            });
            _this.find('.months_list a:not(.active)').each(function(k,element){
                $(element).attr('href', '');
            });
        };

        __init();
    }


    $(document).ready(function(){

        if(document.querySelector('#whats_on_calendar')){
            $('#whats_on_calendar').timeline();
        }
        else if(document.querySelector('.ap_whats_on_block')){
            $('.ap_whats_on_block').timeline();
        }
    });


}(jQuery))
